import { useEffect, useState } from "react";
import { StepHeaderEntity } from "../../../../../entities/UIEntities/Form Entities/StepHeaderEntity";
import {
  ADD_PARKER_FORM_STEPS,
  INPUTS_PROPS,
} from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import store from "../../../../../redux/Store";
import Icons from "../../../../../resources/icons/Icons";
import Strings from "../../../../../resources/Strings";
import { getProgressBarValue } from "../../../../../utils/CommonUtils";
import { getErrorMessage, isPhoneNumber, isRequired  } from "../../../../../utils/FormUtils";
import { phoneNumberToSend } from "../../../../../utils/CommonUtils";
//import VerificationPhoneInput from "../../../Inputs/CustomInputs/VerificationPhoneInput";
import classes from "../WizardForm.module.css";
import PhoneInputWithoutVerification from "../../../Inputs/CustomInputs/PhoneInputWithoutVerification";

const SelectedFromGmtUserStep = (props) => {
  const [errors, setErrors] = useState({});
  const [stepHeader,setStepHeader] = useState(new StepHeaderEntity(
    Strings.STEPS_TITLES.GENERAL_DETAILS_MODAL_TITLE,
    Strings.STEPS_TITLES.GENERAL_DETAILS_MODAL_SUB_TITLE,
    Icons.NEW_PARKER,
    getProgressBarValue(ADD_PARKER_FORM_STEPS.GENERAL_DETAILS)
  ));

  useEffect(() => {
    if (props.currentStep === ADD_PARKER_FORM_STEPS.GENERAL_DETAILS) {
      const hasError = Object.values(errors).some((hasError) => hasError);
      props.handleCurrentStepValidity(hasError);
    }
  }, [errors]);

  useEffect(() => {
    store.dispatch(commonActions.setSideModal({ modalHeader: stepHeader }));
  }, [stepHeader]);
  
  if (props.currentStep !== ADD_PARKER_FORM_STEPS.GENERAL_DETAILS) {
    return null;
  }

  const handleError = (error) => {
    setErrors((prevState) => ({
      ...prevState,
      ...error,
    }));
  };

  const handleChange = (event) => {
    props.handleChange({ ...event, [INPUTS_PROPS.VERIFIED_FROM_GMT]: true });
  };

  return (
    <div className={classes.stepContainer}>
      <div className={classes.stepTitle}>
        {Strings.STEPS_TITLES.GENERAL_DETAILS_TITLE}
      </div>
      <span className={classes.stepSubTitle}>
        {Strings.STEPS_TITLES.GENERAL_DETAILS_SUB_TITLE_GMT_USER}
      </span>

      <div className={classes.fileds}>

      <PhoneInputWithoutVerification 
          validateExsistingUser={true}
          label={Strings.INPUT_LABELS.PHONE_NUMBER}
          id={INPUTS_PROPS.PHONE_NUMBER}
          phoneVerifiedId={INPUTS_PROPS.PHONE_VERIFIED}
          value={props.phoneNumber}
          actionText={
            props.isEditMode ? Strings.CHANGE : Strings.SEARCH /* Strings.CONFIRM_VERIFY */
          }
          dialingCode={props.dialingCode}
          hasError={!isRequired(props.phoneNumber).isValid || !isPhoneNumber(props.dialingCode + phoneNumberToSend(props.dialingCode, props.phoneNumber)).isValid}
          errorMessage={getErrorMessage(isRequired(props.phoneNumber)) ? getErrorMessage(isRequired(props.phoneNumber)) : getErrorMessage(isPhoneNumber(props.dialingCode + phoneNumberToSend(props.dialingCode, props.phoneNumber)))}
          isPhoneVerified={props.isPhoneVerified}
          onChange={handleChange}
          // handleError={handleError}
          isStepSubmitted={props.isStepSubmitted}
          // hasError={!isPhoneNumber(props.phoneNumber).isValid}
          // errorMessage={getErrorMessage(isPhoneNumber(props.phoneNumber))}
          fromGmt={props.fromGmt}
          isVerifyValidationNeeded={false}
          selectedSites={props.selectedSites}
        />


        {/* <VerificationPhoneInput
          validateExsistingUser={true}
          label={Strings.INPUT_LABELS.PHONE_NUMBER}
          id={INPUTS_PROPS.PHONE_NUMBER}
          phoneVerifiedId={INPUTS_PROPS.PHONE_VERIFIED}
          value={props.phoneNumber}
          actionText={
            props.isEditMode ? Strings.CHANGE : Strings.CONFIRM_VERIFY
          }
          dialingCode={props.dialingCode}
          hasError={!isRequired(props.phoneNumber).isValid || !isPhoneNumber(props.dialingCode + phoneNumberToSend(props.dialingCode, props.phoneNumber)).isValid}
          errorMessage={getErrorMessage(isRequired(props.phoneNumber)) ? getErrorMessage(isRequired(props.phoneNumber)) : getErrorMessage(isPhoneNumber(props.dialingCode + phoneNumberToSend(props.dialingCode, props.phoneNumber)))}
          isPhoneVerified={props.isPhoneVerified}
          onChange={handleChange}
          // handleError={handleError}
          isStepSubmitted={props.isStepSubmitted}
          // hasError={!isPhoneNumber(props.phoneNumber).isValid}
          // errorMessage={getErrorMessage(isPhoneNumber(props.phoneNumber))}
          fromGmt={props.fromGmt}
          selectedSites={props.selectedSites}
        /> */}
      </div>
    </div>
  );
};

export default SelectedFromGmtUserStep;
